<template>
  <div id="PurchaseMgmt" class="purchase-mgmt-page">
    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">视图类型</span>
            <el-select placeholder="视图类型" size="small" v-model="params.viewType">
              <el-option label="SKU" value="1"></el-option>
              <el-option label="产品" value="2"></el-option>
              <el-option label="产品-颜色" value="3"></el-option>
              <el-option label="机型" value="4"></el-option>
              <el-option label="产品-机型" value="5"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品类型</span>
            <el-select class="filter-select-wide" placeholder="全部" size="small" @change="onProductTypeChange" v-model="productTypeList" filterable multiple collapse-tags clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品颜色</span>
            <el-select placeholder="全部" size="small" v-model="params.productColor" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">机型</span>
            <el-select placeholder="全部" size="small" v-model="productModel" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">SKU</span>
            <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku" class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">状态</span>
            <el-select placeholder="全部" size="small" v-model="params.status" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="采购中" value="0"></el-option>
              <el-option label="采购完成" value="1"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">采购供应商</span>
            <el-select class="filter-select-wide" placeholder="全部" size="small" @change="onSupplierIdChange" v-model="supplierIdList" filterable multiple collapse-tags clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="supplier in supplierList" :key="supplier.supplierId" :label="supplier.supplierShortName" :value="supplier.supplierId"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">采购日期</span>
            <el-date-picker v-model="date" size="small" type="daterange" range-separator="至" start-placeholder="开始" end-placeholder="结束" :picker-options="pickerOptions" class="filter-date"></el-date-picker>
          </div>
          <div class="filter-item">
            <span class="filter-label">排序类型</span>
            <el-select placeholder="请选择" size="small" v-model="params.sortKey">
              <el-option label="待退款" value="waitForRefund"></el-option>
              <el-option label="待发货" value="waitForShipped"></el-option>
              <el-option label="已退款" value="refunded"></el-option>
              <el-option label="待补货" value="waitForReplenishment"></el-option>
              <el-option label="多到库存" value="overStock"></el-option>
              <el-option label="已退回" value="returned"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">增速排序</span>
            <el-select placeholder="请选择" size="small" v-model="params.sortType">
              <el-option label="升序" :value="1"></el-option>
              <el-option label="降序" :value="-1"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">开票状态</span>
            <el-select placeholder="全部" size="small" v-model="params.invoiceState" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="已开票" :value="1"></el-option>
              <el-option label="未开票" :value="0"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">商品类型</span>
            <el-select placeholder="全部" size="small" v-model="params.purchaseProductType" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="产品" :value="1"></el-option>
              <el-option label="纸箱" :value="2"></el-option>
              <el-option label="花熊链子" :value="3"></el-option>
            </el-select>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="queryBtn">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-plus" @click="addBtn">新增</el-button>
            <el-button size="small" icon="el-icon-upload2" @click="importBtn">导入</el-button>
            <el-button size="small" @click="goColorMgmt">配置采购颜色</el-button>
            <el-button size="small" @click="updateLocalInventory">更新本地库存</el-button>
          </div>
          <div class="batch-toolbar" v-if="multipleSelection.length > 0">
            <el-button type="primary" size="small" @click="editPurchase(1)">已采购</el-button>
            <el-button type="primary" size="small" @click="editPurchase(2)">已到货</el-button>
            <el-button type="danger" size="small" plain @click="editPurchase(5)">未采购</el-button>
            <el-button type="danger" size="small" plain @click="editPurchase(4)">未到货</el-button>
            <el-button v-if="shopType == 6" type="primary" size="small" @click="editPurchase(3)">已发货</el-button>
            <el-button type="primary" size="small" plain @click="exportProductBtn">导出</el-button>
            <el-button type="primary" size="small" plain @click="exportMaterialBtn">导出材料</el-button>
            <el-button type="primary" size="small" @click="createPayOrderBtn">生产支付订单</el-button>
            <el-button v-if="params.viewType == 1" type="danger" size="small" plain @click="batchDeletePurchase">批量删除</el-button>
            <el-button size="small" @click="cancelSelected">取消选中</el-button>
            <span class="toolbar-tip">已选 {{ multipleSelection.length }} 条</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table ref="table" :data="tableData" border stripe size="mini" :height="screenHeight" :highlight-current-row="true" show-summary class="mgmt-table" header-cell-class-name="table-header-cell" @selection-change="handleSelectionChange" @cell-click="handleCellClick" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
          <el-table-column type="selection" width="55" :selectable="selectable" align="center"></el-table-column>
          <el-table-column prop="date" label="采购日期" width="80px" align="center" :key="101"> </el-table-column>
          <el-table-column prop="shopName" label="店铺名称" width="60px" :key="102" sortable> </el-table-column>
          <el-table-column prop="productName" label="产品名称" width="100px" :key="103" sortable> </el-table-column>
          <!-- <el-table-column v-if="params.viewType == 1 || params.viewType == 3" prop="productColorName" label="产品颜色" width="80px" :key="104"> </el-table-column> -->
          <el-table-column v-if="params.viewType == 1 || params.viewType == 3" prop="purchaseColorName" label="产品颜色" width="100px" :key="1041" sortable> </el-table-column>
          <el-table-column v-if="params.viewType == 1 || params.viewType == 4 || params.viewType == 5" prop="model" label="机型" width="80px" :key="124" sortable> </el-table-column>
          <el-table-column v-if="params.viewType == 1" prop="sku" label="SKU" width="200px" :key="105" sortable> </el-table-column>
          <el-table-column v-if="params.viewType == 1" prop="fnsku" label="FNSKU" width="90px" :key="1051"> </el-table-column>
          <el-table-column v-if="params.viewType == 1" prop="logisticsTypeName" label="头程物流" width="80px" align="right" :key="106"> </el-table-column>
          <el-table-column prop="planPurchase" label="应采购" width="80px" align="right" :key="107" style="cursor: pointer" sortable>
            <template slot-scope="scope">
              <div style="cursor: pointer">{{ scope.row.planPurchase }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="alreadyPurchased" label="已采购" width="80px" align="right" :key="108" sortable>
            <template slot-scope="scope">
              <div style="cursor: pointer">{{ scope.row.alreadyPurchased }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="waitForPurchase" label="待采购" width="80px" align="right" :key="109" sortable> </el-table-column>
          <el-table-column prop="arrived" label="已到货" width="80px" align="right" :key="110" sortable>
            <template slot-scope="scope">
              <div style="cursor: pointer">{{ scope.row.arrived }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="shipped" label="已发货" width="80px" align="right" :key="111" sortable> </el-table-column>
          <el-table-column prop="waitForShipped" label="待发货" width="80px" align="right" :key="112" sortable> </el-table-column>
          <el-table-column prop="outOfStock" label="实际缺货" width="80px" align="right" :key="113" sortable> </el-table-column>
          <el-table-column prop="waitForRefund" label="待退款" width="80px" align="right" :key="114" sortable> </el-table-column>
          <el-table-column prop="refunded" label="已退款" width="80px" align="right" :key="115" sortable>
            <template slot-scope="scope">
              <div style="cursor: pointer">{{ scope.row.refunded }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="waitForReplenishment" label="待补货" width="80px" align="right" :key="116" sortable> </el-table-column>
          <el-table-column prop="overStock" label="多到库存" width="80px" align="right" :key="117" sortable> </el-table-column>
          <el-table-column prop="returned" label="已退回" width="80px" align="right" :key="118" sortable>
            <template slot-scope="scope">
              <div style="cursor: pointer">{{ scope.row.returned }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="actualExcessStock" label="实际多收库存" width="80px" align="right" :key="119" sortable> </el-table-column>
          <el-table-column prop="notArrived" label="已采未到" width="80px" align="right" :key="120" sortable> </el-table-column>
          <el-table-column prop="supplierShortName" label="供应商名称" width="100px" :key="129" sortable> </el-table-column>
          <el-table-column prop="invoiceState" label="开票状态" width="60px" align="right" :key="130" sortable>
            <template slot-scope="scope">
              <div>{{ scope.row.invoiceState == 1 ? "已开票" : "" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300" fixed="right" class-name="action-col">
            <template slot-scope="scope">
              <div class="action-cell action-cell-nowrap">
                <el-button v-if="scope.row.alreadyPurchased == 0 && params.viewType == 1" type="text" size="small" @click="deletePurchase(scope.row)">删除</el-button>
                <el-button v-if="params.viewType == 2" type="text" size="small" @click="editSupplier(scope.row)">编辑供应商</el-button>
                <el-button v-if="params.viewType == 2" type="text" size="small" @click="editInvoiceState(scope.row)">编辑开票状态</el-button>
                <el-button v-if="scope.row.purchaseId > 0 && params.viewType == 1" type="text" size="small" @click="showOpreateLog(scope.row)">操作记录</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>
      </div>
    </div>

    <el-dialog title="导入" :visible.sync="dialogFormVisible" width="35%">
      <el-form :model="form">
        <el-form-item label="导入采购" label-width="80">
          <el-upload ref="uploadPurchase" class="upload-demo" action="/node/importPurchase" :auto-upload="false" :on-success="onUploadSuccess" :before-upload="beforeUpload" :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="importData">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导出" :visible.sync="dialogExportVisible" width="760px">
      <el-table :data="exportDataList" stripe size="mini" :highlight-current-row="true" show-summary>
        <el-table-column label="序号" width="60px" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="采购日期" width="100px" align="center" :key="101"> </el-table-column>
        <el-table-column prop="productName" label="产品名称" width="150px" :key="103"> </el-table-column>
        <el-table-column prop="purchaseColorName" label="产品颜色" width="80px" :key="104"> </el-table-column>
        <el-table-column prop="model" label="机型" width="80px" :key="124"> </el-table-column>
        <el-table-column prop="planPurchase" label="应采购数量" width="80px" align="right" :key="107"> </el-table-column>
        <el-table-column prop="alreadyPurchased" label="已采购数量" width="80px" align="right" :key="109"> </el-table-column>
        <el-table-column prop="arrived" label="已到货数量" width="80px" align="right" :key="108"> </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogExportVisible = false">关 闭</el-button>
        <el-button class="opreate-btn" type="primary" size="small"><download-excel :data="exportDataList" :fields="exportTitles" :name="getExportName()">采购导出</download-excel></el-button>
        <el-button class="opreate-btn" type="primary" size="small"><download-excel :data="exportStoreDataList" :fields="exportStoreTitles" :name="getExportName()">仓库导出</download-excel></el-button>
      </div>
    </el-dialog>

    <el-dialog title="导出材料" :visible.sync="dialogExportMaterialVisible" width="760px">
      <el-table :data="exportMaterialDataList" stripe size="mini" :highlight-current-row="true" show-summary v-loading="exportMaterialLoading" element-loading-text="加载中...">
        <el-table-column label="序号" width="60px" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="采购日期" width="100px" align="center"> </el-table-column>
        <el-table-column prop="materialName" label="材料名称" width="150px"> </el-table-column>
        <el-table-column prop="purchaseColorName" label="采购颜色" width="80px"> </el-table-column>
        <el-table-column prop="model" label="机型" width="80px"> </el-table-column>
        <el-table-column prop="planPurchase" label="应采购数量" width="80px" align="right"> </el-table-column>
        <el-table-column prop="alreadyPurchased" label="已采购数量" width="80px" align="right"> </el-table-column>
        <el-table-column prop="arrived" label="已到货数量" width="80px" align="right"> </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogExportMaterialVisible = false">关 闭</el-button>
        <el-button class="opreate-btn" type="primary" size="small"><download-excel :data="exportMaterialDataList" :fields="exportMaterialTitles" :name="getExportMaterialName()">材料导出</download-excel></el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增采购" :visible.sync="dialogAddPurchaseVisible" width="600px">
      <div class="form-line">
        <span class="form-label">店铺类型</span>
        <el-radio-group v-model="addParams.platformType">
          <el-radio :label="1">Amazon</el-radio>
          <el-radio :label="2">Temu</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line">
        <span class="form-label">商品类型</span>
        <el-radio-group v-model="addParams.purchaseProductType">
          <el-radio :label="1">产品</el-radio>
          <el-radio :label="2">纸箱</el-radio>
          <el-radio :label="3">花熊链子</el-radio>
        </el-radio-group>
      </div>
      <div class="form-line" v-if="addParams.purchaseProductType == 1">
        <span class="form-label">SKU</span>
        <el-input class="form-input" placeholder="请输入" v-model="addParams.sku" size="small" clearable> </el-input>
      </div>
      <div class="form-line" v-if="addParams.purchaseProductType == 2">
        <span class="form-label">箱子规格</span>
        <el-select class="box-select" placeholder="请选择" size="small" v-model="addParams.boxId" style="width: 220px">
          <el-option label="请选择" value=""></el-option>
          <el-option v-for="box in outStockBoxs" :label="getBoxLabel(box)" :value="box.boxId"></el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="addParams.purchaseProductType == 2 || addParams.purchaseProductType == 3">
        <span class="form-label"><span>*</span>店铺名称</span>
        <el-radio-group v-model="addParams.shopType">
          <el-radio :label="1">灵柚</el-radio>
          <el-radio :label="2">萧发</el-radio>
          <el-radio :label="3">誉腾</el-radio>
          <el-radio :label="4">甄昂</el-radio>
          <el-radio :label="8">众联</el-radio>
        </el-radio-group>
      </div>

      <div class="form-line">
        <span class="form-label">采购日期</span>
        <el-date-picker class="form-date" v-model="addDate" type="date" placeholder="选择日期" size="small"> </el-date-picker>
      </div>
      <div class="form-line">
        <span class="form-label">应采购</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="addParams.planPurchase" size="small" @input="handleAddChange" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">已采购</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="addParams.alreadyPurchased" size="small" @input="handleAddChange" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">待采购</span>
        <span class="form-text">{{ addParams.waitForPurchase }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">已到货</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="addParams.arrived" size="small" @input="handleAddChange" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">实际缺货</span>
        <span class="form-text">{{ addParams.outOfStock }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">待退款</span>
        <span class="form-text">{{ addParams.waitForRefund }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">已退款</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="addParams.refunded" size="small" @input="handleAddChange" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">待补货</span>
        <span class="form-text">{{ addParams.waitForReplenishment }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">多到库存</span>
        <span class="form-text">{{ addParams.overStock }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">已退回</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="addParams.returned" size="small" @input="handleAddChange" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">实际多收库存</span>
        <span class="form-text">{{ addParams.overStock }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">已采未到</span>
        <span class="form-text">{{ addParams.notArrived }}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogAddPurchaseVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="handleAddClick">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="设置供应商" :visible.sync="dialogEditSupplierVisible" width="600px">
      <div class="form-line">
        <div class="form-line">
          <span class="form-label">采购日期</span>
          <span class="form-text">{{ supplierParams.date }}</span>
        </div>
        <div class="form-line">
          <span class="form-label">产品名称</span>
          <span class="form-text">{{ supplierParams.productName }}</span>
        </div>
        <span class="form-label">供应商</span>
        <el-select placeholder="产品类型" size="small" v-model="supplierParams.supplierId" filterable>
          <el-option label="请选择" value=""></el-option>
          <el-option v-for="supplier in supplierList" :key="supplier.supplierId" :label="supplier.supplierShortName" :value="supplier.supplierId"></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogEditSupplierVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="handleEditSupplier">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="设置开票状态" :visible.sync="dialogInvoiceStateVisible" width="600px">
      <div class="form-line">
        <span class="form-label">开票状态</span>
        <el-select placeholder="产品类型" size="small" v-model="invoiceParams.invoiceState">
          <el-option label="已开票" :value="1"></el-option>
          <el-option label="未开票" :value="0"></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogInvoiceStateVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="handleEditInvoiceState">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="生产支付订单" :visible.sync="dialogCreatePayOrderVisible" width="920px" custom-class="pay-order-dialog" :close-on-click-modal="false">
      <div class="pay-order-section">
        <div class="section-title">产品明细</div>
        <el-table :data="payOrderPreviewList" border stripe size="mini" show-summary :summary-method="getPayOrderSummaries" v-loading="payOrderPreviewLoading" max-height="320">
          <el-table-column label="序号" width="50" align="center" prop="index"></el-table-column>
          <el-table-column prop="materialName" label="材料名称" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.materialName || scope.row.productName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="purchaseQuantity" label="采购数量" width="80" align="right"></el-table-column>
          <el-table-column prop="unitPrice" label="单价" width="90" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.unitPrice) }}</template>
          </el-table-column>
          <el-table-column prop="purchaseAmount" label="采购金额" width="90" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.purchaseAmount) }}</template>
          </el-table-column>
          <el-table-column prop="taxRate" label="税率" width="70" align="right">
            <template slot-scope="scope">{{ formatPayOrderTaxRate(payOrderSupplierTaxRate) }}</template>
          </el-table-column>
          <el-table-column prop="taxAmount" label="税费" width="80" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.taxAmount) }}</template>
          </el-table-column>
          <el-table-column prop="payableAmount" label="应付金额" width="90" align="right">
            <template slot-scope="scope">{{ formatMoney(scope.row.payableAmount) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pay-order-form">
        <div class="section-title">支付信息</div>
        <div class="form-grid">
          <div class="form-item wide">
            <span class="form-label">采购供应商</span>
            <el-select v-model="payOrderForm.supplierId" size="small" filterable placeholder="请选择供应商" @change="onPayOrderSupplierChange">
              <el-option v-for="supplier in supplierList" :key="supplier.supplierId" :label="supplier.supplierShortName" :value="supplier.supplierId"></el-option>
            </el-select>
            <span class="tax-label">税率：{{ formatPayOrderTaxRate(payOrderSupplierTaxRate) }}</span>
          </div>
          <div class="form-item wide">
            <span class="form-label">运费</span>
            <el-input v-model.number="payOrderForm.freight" size="small" type="number" @input="calcPayOrderTotal"></el-input>
          </div>
          <div class="form-item wide">
            <span class="form-label">平台优惠</span>
            <el-input v-model.number="payOrderForm.platformDiscount" size="small" type="number" @input="calcPayOrderTotal"></el-input>
          </div>
          <div class="form-item wide">
            <span class="form-label">退换货费</span>
            <el-input v-model.number="payOrderForm.returnExchangeFee" size="small" type="number" @input="calcPayOrderTotal"></el-input>
          </div>
          <div class="form-item wide">
            <span class="form-label">其他费用</span>
            <el-input v-model.number="payOrderForm.otherFee" size="small" type="number" @input="calcPayOrderTotal"></el-input>
          </div>
          <div class="form-item wide">
            <span class="form-label">下单平台</span>
            <el-radio-group v-model="payOrderForm.orderPlatform" size="small">
              <el-radio label="对公">对公</el-radio>
              <el-radio label="平台">平台</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="amount-summary">
          <div class="amount-row">
            <span class="amount-label">应付金额</span>
            <span class="amount-value payable">{{ formatMoney(payOrderForm.payableAmount) }}</span>
          </div>
          <div class="amount-row">
            <span class="amount-label">实付金额</span>
            <el-input v-model.number="payOrderForm.actualPaidAmount" size="small" type="number" class="amount-input" @input="onPayOrderActualPaidInput"></el-input>
          </div>
          <div class="amount-row">
            <span class="amount-label">差额</span>
            <span class="amount-value" :class="payOrderAmountDiffClass">{{ formatPayOrderAmountDiff(payOrderAmountDiff) }}</span>
            <span class="amount-tip">（实付金额 - 应付金额）</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCreatePayOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmCreatePayOrder" :loading="payOrderSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="opreateLogVisible" width="1200px">
      <el-table :data="operateHistory" border style="width: 100%" :height="screenHeight" cell-class-name="table-cell" row-class-name="table-row" header-cell-class-name="table-header-cell">
        <el-table-column label="序号" width="50px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="70px"> </el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="180px"> </el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="150px"> </el-table-column>
        <el-table-column prop="bussinessId" label="业务ID" width="150px"> </el-table-column>
        <el-table-column prop="content" label="操作详情"> </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="opreateLogVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules, payOrderModules } from "@r";
import { activeProducts, allActiveProducts, colors, models } from "../../utils/constant.js";
import { PAY_ORDER_STATUS } from "../../constants/payOrderStatus";

export default {
  data() {
    return {
      shopType: localStorage.getItem("shopType"),
      total: 0,
      pageCount: 1,
      productList: localStorage.getItem("shopType") == 6 ? allActiveProducts : activeProducts,
      colorList: colors,
      modelList: models,
      dialogFormVisible: false,
      dialogExportVisible: false,
      dialogExportMaterialVisible: false,
      dialogAddPurchaseVisible: false,
      opreateLogVisible: false,
      dialogInvoiceStateVisible: false,
      form: {
        file: null,
        type: 0,
      },
      totalPage: 1,
      businessDataList: [],
      exportBusinessDataList: [],
      dateList: [],
      activeRowIndex: -1,
      activeColumnIndex: -1,
      productModel: "",
      productTypeList: [],
      supplierIdList: [],
      params: {
        sku: "",
        status: "0",
        viewType: "2",
        productType: "",
        productColor: "",
        date: "",
        productModel: "",
        beginIndex: 0,
        pageSize: 1000,
        supplierId: "",
        sortKey: "",
        sortType: "",
        productTypeList: "[]",
        supplierIdList: "[]",
        invoiceState: "",
        purchaseProductType: "",
      },
      addParams: {
        platformType: 1,
        sku: "",
        planPurchase: 0,
        alreadyPurchased: 0,
        waitForPurchase: 0,
        arrived: 0,
        outOfStock: 0,
        waitForRefund: 0,
        refunded: 0,
        waitForReplenishment: 0,
        overStock: 0,
        returned: 0,
        notArrived: 0,
        purchaseProductType: 1,
        boxId: "",
        shopType: 1,
        shopName: "",
      },
      invoiceParams: {
        invoiceState: 0,
      },
      addDate: new Date(),
      uploadCount: 0,
      screenHeight: document.body.clientHeight - 64 - 132 - 68,
      multipleSelection: [],
      exportDataList: [],
      exportStoreDataList: [],
      exportMaterialDataList: [],
      exportMaterialLoading: false,
      dialogCreatePayOrderVisible: false,
      payOrderPreviewLoading: false,
      payOrderSubmitLoading: false,
      payOrderPreviewList: [],
      payOrderMeta: { taxRate: 0, productAmount: 0 },
      payOrderPreviewShouldSyncActualPaid: false,
      payOrderForm: {
        supplierId: "",
        freight: 0,
        platformDiscount: 0,
        returnExchangeFee: 0,
        otherFee: 0,
        orderPlatform: "对公",
        actualPaidAmount: 0,
        payableAmount: 0,
      },
      loading: true,
      date: [],
      dialogEditSupplierVisible: false,
      supplierParams: { supplierId: "", supplierName: "", supplierShortName: "", shopType: "" },
      supplierList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近三天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      outStockBoxs: [],
      operateHistory: [],
    };
  },
  watch: {
    productModel: {
      handler: function (newValue, oldValue) {
        let blankReg = new RegExp(" ", "igm");
        let productModel = newValue.replace(blankReg, "");
        this.params.productModel = productModel;
      },
    },
    "params.viewType": {
      handler: function (newValue, oldValue) {
        this.params.pageSize = newValue == 1 ? 200 : 1000;
      },
      deep: true,
    },
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  mounted() {
    this.getData();
    this.fetchOutStockBoxs();
    this.fetchSuppliers();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    cancelSelected() {
      this.$refs.table.clearSelection();
    },
    fetchSuppliers() {
      requestModules.fetchSuppliers({ beginIndex: 0, pageSize: 1000 }).then(res => {
        this.supplierList = res.ldata;
      });
    },
    fetchOutStockBoxs() {
      requestModules.fetchOutStockBoxs({ status: 1 }).then(res => {
        this.outStockBoxs = res.ldata;
      });
    },
    onProductTypeChange(checkList) {
      let isAllChecked = false;
      checkList.forEach(productType => productType == "" && (isAllChecked = true));
      if (isAllChecked) {
        this.productTypeList = [];
        this.productList.forEach(product => this.productTypeList.push(product.productType));
      }
    },
    onSupplierIdChange(checkList) {
      let isAllChecked = false;
      checkList.forEach(supplierId => supplierId == "" && (isAllChecked = true));
      if (isAllChecked) {
        this.supplierIdList = [];
        this.supplierList.forEach(supplier => this.supplierIdList.push(supplier.supplierId));
      }
    },
    showOpreateLog(row) {
      this.operateHistory = [];
      this.opreateLogVisible = true;
      requestModules
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          userId: this.userId,
          bussinessId: row.purchaseId,
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取操作记录失败",
            });
            return;
          }

          this.operateHistory = res.ldata;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    getBoxLabel(box) {
      return `${box.length}*${box.width}*${box.height} _ (${box.bubbleWeight}KG)`;
    },
    editSupplier(row) {
      this.dialogEditSupplierVisible = true;
      this.supplierParams.date = row.date;
      this.supplierParams.productName = row.productName;
      this.supplierParams.productType = row.productType;
      this.supplierParams.shopType = row.shopType;
    },
    editInvoiceState(row) {
      this.dialogInvoiceStateVisible = true;
      this.invoiceParams.date = row.date;
      this.invoiceParams.productName = row.productName;
      this.invoiceParams.productType = row.productType;
      this.invoiceParams.shopType = row.shopType;
    },
    updateLocalInventory() {
      this.$confirm("是否确认更新本地库存？", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.statisticLocalInventorys({}).then(res => {
          this.$confirm("更新完成", "提示", {
            confirmButtonText: "确定",
            type: "info",
          }).then(() => {});
        });
      });
    },
    handleAddChange() {
      this.addParams["waitForPurchase"] = parseInt(this.addParams["planPurchase"] - this.addParams["alreadyPurchased"]);
      this.addParams["shipped"] = 0;
      this.addParams["waitForShipped"] = parseInt(this.addParams["arrived"] - this.addParams["shipped"]);
      // 缺货
      this.addParams["outOfStock"] = parseInt(this.addParams["alreadyPurchased"] - this.addParams["arrived"]);
      // 多到货
      this.addParams["overStock"] = parseInt(this.addParams["arrived"] - this.addParams["alreadyPurchased"]);
      this.addParams["waitForRefund"] = parseInt(this.addParams["outOfStock"]);
      this.addParams["waitForReplenishment"] = parseInt(this.addParams["waitForRefund"] - this.addParams["refunded"]);
      this.addParams["notArrived"] = parseInt(this.addParams["alreadyPurchased"]) > 0 ? parseInt(this.addParams["alreadyPurchased"] - this.addParams["arrived"] - this.addParams["refunded"] + parseInt(this.addParams["returned"])) : 0;

      this.addParams["actualExcessStock"] = this.addParams["overStock"] - this.addParams["returned"];

      this.addParams["notArrived"] < 0 && (this.addParams["notArrived"] = 0);
      this.addParams["overStock"] < 0 && (this.addParams["overStock"] = 0);
      this.addParams["outOfStock"] < 0 && (this.addParams["outOfStock"] = 0);
      this.addParams["waitForReplenishment"] < 0 && (this.addParams["waitForReplenishment"] = 0);
      this.addParams["waitForShipped"] < 0 && (this.addParams["waitForShipped"] = 0);
      this.addParams["actualExcessStock"] < 0 && (this.addParams["actualExcessStock"] = 0);
      this.addParams["waitForPurchase"] < 0 && (this.addParams["waitForPurchase"] = 0);

      this.addParams.status = 0;
      this.addParams["notArrived"] == 0 && this.addParams["alreadyPurchased"] > 0 && this.addParams["planPurchase"] == this.addParams["alreadyPurchased"] && (this.addParams.status = 1);

      // this.addParams["alreadyPurchased"] > 0 && this.addParams["notArrived"] == 0 && (this.addParams.status = 1);
      this.addParams["alreadyPurchased"] == 0 && this.addParams["arrived"] != 0 && this.addParams["notArrived"] == 0 && (this.addParams.status = 1);
    },
    handleCellClick(row, column, cell, event) {
      let property = column.property;
      console.log(property);
      if (property != "planPurchase" && property != "alreadyPurchased" && property != "arrived" && property != "refunded" && property != "returned" && property != "shipped") {
        return;
      }

      if (property == "shipped" && this.shopType != 6 && row.purchaseProductType == 1) {
        return;
      }

      if (this.params.viewType != 1) {
        return;
      }

      let params = {
        sku: row.sku,
        property,
        id: row._id,
      };

      this.$prompt("请输入修改后" + column.label + "数量", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^-?\d+$/,
        inputErrorMessage: "请输入正确的数量",
        inputValue: row[property],
      })
        .then(({ value }) => {
          params.value = value;
          requestModules.addOrUpdatePurchase(params).then(res => {
            this.$message({
              type: "success",
              message: "修改完成",
            });
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$nextTick(() => {
        this.calculateHeight();
      });
    },
    addBtn() {
      this.dialogAddPurchaseVisible = true;
    },
    handleAddClick() {
      this.$confirm("是否确认手动新增采购记录？", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        this.dialogAddPurchaseVisible = false;
        this.addDate && (this.addParams.date = this.addDate.format("yyyy-MM-dd"));

        if (this.addParams.purchaseProductType == 2) {
          let box = this.outStockBoxs.find(box => box.boxId == this.addParams.boxId);
          if (box) {
            this.addParams.boxName = "纸箱";
            this.addParams.boxModel = `${box.length}*${box.width}*${box.height} _ (${box.bubbleWeight}KG)`;
            this.addParams.shopName = this.getShopName(this.addParams.shopType);
          }
        } else if (this.addParams.purchaseProductType == 3) {
          this.addParams.shopName = this.getShopName(this.addParams.shopType);
        }

        requestModules.addOrUpdatePurchase(this.addParams).then(res => {
          this.getData();
        });
      });
    },
    getShopName(shopType) {
      let shopName = "";
      shopType == 1 && (shopName = "灵柚");
      shopType == 2 && (shopName = "萧发");
      shopType == 3 && (shopName = "誉腾");
      shopType == 4 && (shopName = "甄昂");
      shopType == 8 && (shopName = "众联");
      return shopName;
    },
    editPurchase(type) {
      let title = "";
      type == 1 && (title = "是否确认操作已采购");
      type == 2 && (title = "是否确认操作已到货");
      type == 3 && (title = "是否确认操作已发货");
      type == 4 && (title = "是否确认操作未发货");
      type == 5 && (title = "是否确认操作未采购");
      type == 6 && (title = "是否确认操作批量删除");
      let params = {
        ...this.params,
        editType: type,
      };
      let productTypeSet = new Set();
      let skuSet = new Set();
      let modelSet = new Set();
      let productTypeAndColorSet = new Set();
      let productTypeAndModelSet = new Set();

      // this.$confirm(title, "提示", {
      //   confirmButtonText: "确定",
      //   type: "info",
      // }).then(() => {
      //   this.multipleSelection.forEach(item => {
      //     requestModules.deletePurchase({ id: item._id }).then(res => {});
      //   });
      // });

      this.multipleSelection.forEach(item => {
        productTypeSet.add({
          productType: item.productType,
          date: item.date,
          shopType: item.shopType,
        });
        skuSet.add({
          sku: item.sku,
          date: item.date,
          shopType: item.shopType,
        });
        modelSet.add({
          model: item.model,
          date: item.date,
          shopType: item.shopType,
        });
        productTypeAndColorSet.add({
          productType: item.productType,
          productColor: item.productColor,
          date: item.date,
          shopType: item.shopType,
        });
        productTypeAndModelSet.add({
          productType: item.productType,
          model: item.model,
          date: item.date,
          shopType: item.shopType,
        });
      });
      params.productTypes = JSON.stringify([...productTypeSet]);
      params.skus = JSON.stringify([...skuSet]);
      params.models = JSON.stringify([...modelSet]);
      params.productTypesAndColors = JSON.stringify([...productTypeAndColorSet]);
      params.productTypesAndModels = JSON.stringify([...productTypeAndModelSet]);

      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.updatePurchases(params).then(res => {
          this.getData();
        });
      });
      console.log(type);
    },
    handleEditSupplier() {
      let supplierInfo = this.supplierList.find(supplier => supplier.supplierId == this.supplierParams.supplierId);
      if (!supplierInfo) {
        this.$message.error("请选择供应商！");
        return;
      }
      this.supplierParams.supplierName = supplierInfo.supplierName;
      this.supplierParams.supplierShortName = supplierInfo.supplierShortName;
      requestModules.updatePurchasesSupplier(this.supplierParams).then(res => {
        this.getData();
      });

      this.dialogEditSupplierVisible = false;
    },
    handleEditInvoiceState() {
      requestModules.updateInvoiceState(this.invoiceParams).then(res => {
        this.getData();
      });

      this.dialogInvoiceStateVisible = false;
    },
    deletePurchase(row) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.deletePurchase({ id: row._id }).then(res => {
          this.getData();
        });
      });
    },
    // 临时批量删除：SKU 视图下删除全部勾选记录，不校验已采购数量
    batchDeletePurchase() {
      if (this.params.viewType != 1) {
        return;
      }
      let ids = this.multipleSelection.map(item => item._id).filter(id => id);
      if (!ids.length) {
        this.$message.warning("请选择要删除的记录");
        return;
      }
      this.$confirm("确认删除已选 " + ids.length + " 条？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return requestModules.deletePurchases({ ids: JSON.stringify(ids) }).then(res => {
            let deleted = res.mdata && res.mdata.deleted;
            this.$message.success(deleted != null ? "已删除 " + deleted + " 条" : "删除完成");
            this.cancelSelected();
            this.getData();
          });
        })
        .catch(err => {
          if (err === "cancel" || err === "close") {
            return;
          }
          this.$message.error((err && (err.msg || err.message)) || "删除失败");
        });
    },
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - paginationHeight - 12;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    selectable(row, index) {
      // return row.status == 0;
      return true;
    },
    queryBtn() {
      this.getData();
    },
    importBtn() {
      this.dialogFormVisible = true;
    },
    buildExportSelectedList() {
      let selectedList = [];
      this.multipleSelection.forEach(item =>
        selectedList.push({
          date: item.date,
          productType: item.productType,
          productColor: item.productColor,
          model: item.model,
          shopType: item.shopType,
        })
      );
      return selectedList;
    },
    validatePayOrderSelectionSameShop() {
      let shopKeys = new Set();
      this.multipleSelection.forEach(item => {
        if (item.shopType != null && item.shopType !== "") {
          shopKeys.add("type:" + String(item.shopType));
        } else if (item.shopName) {
          shopKeys.add("name:" + item.shopName);
        }
      });
      if (shopKeys.size > 1) {
        this.$message.error("不同店铺的采购记录不能一起生产支付订单");
        return false;
      }
      return true;
    },
    getExportParams() {
      return {
        ...this.params,
        selectedList: JSON.stringify(this.buildExportSelectedList()),
      };
    },
    formatMoney(value) {
      if (value === "" || value === null || value === undefined) {
        return "0.00";
      }
      return parseFloat(value).toFixed(2);
    },
    formatPayOrderTaxRate(value) {
      if (value === "" || value === null || value === undefined) {
        return "0%";
      }
      return (parseFloat(value) * 100).toFixed(0) + "%";
    },
    formatPayOrderAmountDiff(value) {
      if (value > 0) {
        return "+" + this.formatMoney(value);
      }
      return this.formatMoney(value);
    },
    getPayOrderSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "purchaseQuantity") {
          sums[index] = data.reduce((sum, row) => sum + (Number(row.purchaseQuantity) || 0), 0);
          return;
        }
        if (["purchaseAmount", "taxAmount", "payableAmount"].includes(column.property)) {
          sums[index] = this.formatMoney(data.reduce((sum, row) => sum + (Number(row[column.property]) || 0), 0));
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    applyPayOrderLineTaxRates(rows) {
      let taxRate = this.payOrderSupplierTaxRate;
      return (rows || []).map(row => {
        let purchaseAmount = parseFloat(row.purchaseAmount) || 0;
        let taxAmount = parseFloat((purchaseAmount * taxRate).toFixed(2));
        let payableAmount = parseFloat((purchaseAmount + taxAmount).toFixed(2));
        return {
          ...row,
          taxRate,
          taxAmount,
          payableAmount,
        };
      });
    },
    calcPayOrderTotal() {
      let linePayableAmount = this.payOrderPreviewList.reduce((sum, row) => sum + (Number(row.payableAmount) || 0), 0);
      let freight = parseFloat(this.payOrderForm.freight) || 0;
      let platformDiscount = parseFloat(this.payOrderForm.platformDiscount) || 0;
      let returnExchangeFee = parseFloat(this.payOrderForm.returnExchangeFee) || 0;
      let otherFee = parseFloat(this.payOrderForm.otherFee) || 0;
      this.payOrderForm.payableAmount = parseFloat((linePayableAmount + freight - platformDiscount + returnExchangeFee + otherFee).toFixed(2));
    },
    onPayOrderActualPaidInput() {
      if (this.payOrderForm.actualPaidAmount === "" || this.payOrderForm.actualPaidAmount === null) {
        this.payOrderForm.actualPaidAmount = 0;
      }
    },
    onPayOrderSupplierChange() {
      this.payOrderPreviewShouldSyncActualPaid = true;
      this.loadPayOrderPreview();
    },
    syncPayOrderActualPaidAmount() {
      if (this.payOrderPreviewShouldSyncActualPaid) {
        this.payOrderForm.actualPaidAmount = this.payOrderForm.payableAmount;
        this.payOrderPreviewShouldSyncActualPaid = false;
      }
    },
    buildPayOrderPreviewParams() {
      return {
        ...this.getExportParams(),
        supplierId: this.payOrderForm.supplierId || 0,
        freight: this.payOrderForm.freight,
        platformDiscount: this.payOrderForm.platformDiscount,
        returnExchangeFee: this.payOrderForm.returnExchangeFee,
        otherFee: this.payOrderForm.otherFee,
      };
    },
    loadPayOrderPreview() {
      this.payOrderPreviewLoading = true;
      payOrderModules
        .previewPayOrderFromPurchases(this.buildPayOrderPreviewParams())
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "加载支付订单预览失败");
            this.payOrderPreviewList = [];
            return;
          }
          this.payOrderPreviewList = this.applyPayOrderLineTaxRates(res.ldata || []);
          this.payOrderMeta = {
            ...(res.mdata || { taxRate: 0, productAmount: 0 }),
            taxRate: this.payOrderSupplierTaxRate,
          };
          this.calcPayOrderTotal();
          this.syncPayOrderActualPaidAmount();
        })
        .catch(() => {
          this.$message.error("加载支付订单预览失败");
        })
        .finally(() => {
          this.payOrderPreviewLoading = false;
        });
    },
    createPayOrderBtn() {
      if (!this.multipleSelection.length) {
        this.$message.error("请先选择采购记录");
        return;
      }
      if (!this.validatePayOrderSelectionSameShop()) {
        return;
      }
      this.payOrderForm = {
        supplierId: "",
        freight: 0,
        platformDiscount: 0,
        returnExchangeFee: 0,
        otherFee: 0,
        orderPlatform: "对公",
        actualPaidAmount: 0,
        payableAmount: 0,
      };
      this.payOrderPreviewList = [];
      this.payOrderMeta = { taxRate: 0, productAmount: 0 };
      this.payOrderPreviewShouldSyncActualPaid = true;
      this.dialogCreatePayOrderVisible = true;
      this.loadPayOrderPreview();
    },
    confirmCreatePayOrder() {
      if (!this.payOrderForm.supplierId) {
        this.$message.error("请选择采购供应商");
        return;
      }
      if (!this.payOrderPreviewList.length) {
        this.$message.error("没有可生成的采购数据");
        return;
      }

      this.payOrderSubmitLoading = true;
      payOrderModules
        .createPayOrderFromPurchases({
          ...this.buildPayOrderPreviewParams(),
          orderPlatform: this.payOrderForm.orderPlatform,
          actualPaidAmount: this.payOrderForm.actualPaidAmount,
          orderStatus: PAY_ORDER_STATUS.PENDING_ORDER,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "生成失败");
            return;
          }
          this.$message.success("支付订单生成成功");
          this.dialogCreatePayOrderVisible = false;
        })
        .catch(err => {
          this.$message.error(err.message || "生成失败");
        })
        .finally(() => {
          this.payOrderSubmitLoading = false;
        });
    },
    exportProductBtn() {
      this.dialogExportVisible = true;
      requestModules.fetchExportPurchases(this.getExportParams()).then(res => {
        this.exportDataList = [...res.ldata];
        this.exportStoreDataList = [...res.ldata];
        this.exportStoreDataList.sort((a, b) => {
          if (a.shopType == b.shopType) {
            return a.sku.localeCompare(b.sku);
          }
          return a.shopType - b.shopType;
        });
      });
    },
    exportMaterialBtn() {
      this.dialogExportMaterialVisible = true;
      this.exportMaterialLoading = true;
      this.exportMaterialDataList = [];

      requestModules
        .fetchExportPurchaseMaterials(this.getExportParams())
        .then(res => {
          this.exportMaterialDataList = [...(res.ldata || [])];
        })
        .catch(() => {
          this.$message.error("导出材料失败");
        })
        .finally(() => {
          this.exportMaterialLoading = false;
        });
    },
    getExportMaterialName() {
      return "采购材料表_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    importData() {
      this.dialogFormVisible = false;

      this.$refs.uploadPurchase.uploadFiles.length > 0 && this.$refs.uploadPurchase.submit();
    },
    beforeUpload() {
      this.uploadCount++;
      console.log("beforeUpload", this.uploadCount);
    },
    onUploadSuccess(text) {
      this.uploadCount--;
      console.log("onUploadSuccess", this.uploadCount);

      if (this.uploadCount == 0) {
        this.$confirm("导入完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        }).then(() => {
          this.clearUploadedFiles();
        });
      }
    },
    clearUploadedFiles() {
      this.$refs.uploadPurchase.uploadFiles.length > 0 && this.$refs.uploadPurchase.clearFiles();
    },
    getExportName() {
      return "采购计划表_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    productDetail(row) {
      window.open("/client/parentProductAnalysis?productType=" + row.productType);
    },
    goAdvert(row) {
      window.open("/client/advertMgmt?asin=" + row.asin1);
    },
    goColorMgmt() {
      window.open("/client/purchaseMgmt/colorMgmt");
    },
    getData() {
      this.loading = true;
      // this.params.date = this.params.date ? this.params.date.format("yyyy-MM-dd") : "";
      let params = {
        ...this.params,
      };
      if (this.date && this.date.length == 2) {
        params.beginDate = this.date[0].format("yyyy-MM-dd");
        params.endDate = this.date[1].format("yyyy-MM-dd");
      }
      // params.date = this.params.date ? this.params.date.format("yyyy-MM-dd") : "";
      let supplierIdList = [];
      this.supplierIdList.forEach(id => supplierIdList.push(id.toString()));

      params.productTypeList = JSON.stringify(this.productTypeList);
      params.supplierIdList = JSON.stringify(supplierIdList);
      requestModules.fetchPurchases(params).then(res => {
        this.businessDataList = res.ldata;
        this.total = res.total;

        this.loading = false;
      });
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getData();
    },
    handleCellMouseEnter(row, column, cell, event) {
      this.activeRowIndex = cell.parentNode.rowIndex;
      this.activeColumnIndex = cell.cellIndex;
    },
    handleCellMouseLeave() {
      this.activeRowIndex = -1;
      this.activeColumnIndex = -1;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1 || index === 2) {
          sums[index] = "";
          return;
        }

        const values = data.map(item => Number(item["orderCount" + (index - 2)]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = 0;
        }
      });

      return sums;
    },
    getInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 15 && (styleClass = "redBg");
      inventoryDay > 15 && inventoryDay <= 30 && (styleClass = "yellowBg");
      inventoryDay > 30 && inventoryDay <= 90 && (styleClass = "greenBg");
      inventoryDay > 90 && (styleClass = "redText");
      return styleClass;
    },
    getAvailableInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 10 && (styleClass = "redBg");
      inventoryDay > 10 && inventoryDay <= 20 && (styleClass = "yellowBg");
      inventoryDay > 20 && inventoryDay <= 60 && (styleClass = "greenBg");
      inventoryDay > 60 && (styleClass = "redText");
      return styleClass;
    },
    getRecommendPriceStyleClass(row) {
      let styleClass = "";
      row.recommendPrice - row.price > 0 && (styleClass = "greenBg");
      row.recommendPrice - row.price < 0 && (styleClass = "redBg");
      return styleClass;
    },
    getInventoryAgeStyleClass(inventoryAge91To180Days) {
      let styleClass = "";
      inventoryAge91To180Days > 0 && (styleClass = "redBg");
      return styleClass;
    },
    getSellThroughStyleClass(sellThrough) {
      let styleClass = "";
      sellThrough < 1 && (styleClass = "redBg");
      sellThrough >= 1 && sellThrough <= 2 && (styleClass = "yellowBg");
      sellThrough > 2 && (styleClass = "greenBg");
      return styleClass;
    },
  },
  computed: {
    payOrderAmountDiff() {
      let actualPaidAmount = parseFloat(this.payOrderForm.actualPaidAmount) || 0;
      let payableAmount = parseFloat(this.payOrderForm.payableAmount) || 0;
      return parseFloat((actualPaidAmount - payableAmount).toFixed(2));
    },
    payOrderAmountDiffClass() {
      if (this.payOrderAmountDiff > 0) {
        return "positive";
      }
      if (this.payOrderAmountDiff < 0) {
        return "negative";
      }
      return "zero";
    },
    payOrderSupplierTaxRate() {
      let supplier = this.supplierList.find(item => item.supplierId == this.payOrderForm.supplierId);
      if (!supplier || supplier.invoiceTaxRate === undefined || supplier.invoiceTaxRate === null || supplier.invoiceTaxRate === "") {
        return 0;
      }
      let taxRate = parseFloat(supplier.invoiceTaxRate);
      return isNaN(taxRate) ? 0 : taxRate;
    },
    highlightCellStyle() {
      return {
        backgroundColor: "yellow",
      };
    },
    tableData() {
      return this.businessDataList;
    },
    exportTitles() {
      let fields = {
        采购日期: "date",
        SKU: "sku",
        // FNSKU: "fnsku",
        产品名称: "productName",
        颜色: "purchaseColorName",
        机型: "model",
        应采购数量: "planPurchase",
        已采购数量: "alreadyPurchased",
        已到货数量: "arrived",
      };
      return fields;
    },
    exportStoreTitles() {
      let fields = {
        店铺: "shopName",
        采购日期: "date",
        SKU: "sku",
        FNSKU: "fnsku",
        产品名称: "productName",
        颜色: "purchaseColorName",
        机型: "model",
        应采购数量: "planPurchase",
        已采购数量: "alreadyPurchased",
        已到货数量: "arrived",
      };
      return fields;
    },
    exportMaterialTitles() {
      return {
        采购日期: "date",
        材料名称: "materialName",
        采购颜色: "purchaseColorName",
        机型: "model",
        应采购数量: "planPurchase",
        已采购数量: "alreadyPurchased",
        已到货数量: "arrived",
      };
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#PurchaseMgmt {
  .pay-order-section {
    margin-bottom: 16px;
  }

  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 10px;
    padding-left: 8px;
    border-left: 3px solid #409eff;
  }

  .pay-order-form {
    padding: 16px;
    background: #f8f9fb;
    border-radius: 6px;
    border: 1px solid #ebeef5;

    .form-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 12px 24px;
      margin-bottom: 16px;
    }

    .form-item {
      display: flex;
      align-items: center;
      min-width: 240px;

      &.wide {
        width: 100%;
      }

      .el-select,
      .el-input {
        width: 180px;
      }
    }

    .form-label {
      display: inline-block;
      width: 80px;
      flex-shrink: 0;
      color: #606266;
      font-size: 13px;
    }

    .tax-label {
      margin-left: 12px;
      color: #909399;
      font-size: 12px;
    }

    .amount-summary {
      padding-top: 12px;
      border-top: 1px dashed #dcdfe6;
    }

    .amount-row {
      display: flex;
      align-items: center;
      min-height: 36px;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .amount-label {
      width: 80px;
      flex-shrink: 0;
      color: #606266;
      font-size: 13px;
    }

    .amount-value {
      font-size: 16px;
      font-weight: 600;

      &.payable {
        color: #409eff;
      }

      &.positive {
        color: #67c23a;
      }

      &.negative {
        color: #f56c6c;
      }

      &.zero {
        color: #909399;
      }
    }

    .amount-input {
      width: 180px;
    }

    .amount-tip {
      margin-left: 10px;
      color: #909399;
      font-size: 12px;
    }
  }

  .header-box {
    padding: 10px;

    .filter-input-wide {
      width: 160px;
    }

    .filter-toolbar {
      margin-top: 4px;
      padding-top: 10px;
      border-top: 1px dashed #ebeef5;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .filter-actions,
    .batch-toolbar {
      flex-wrap: wrap;
    }

    .filter-actions .el-button,
    .batch-toolbar .el-button {
      width: auto;
      min-width: auto;
      margin: 0;
    }
  }

  .table-container {
    .el-table__fixed-right {
      box-shadow: -4px 0 8px rgba(0, 0, 0, 0.08);
    }

    .el-table__fixed-right-patch {
      background: #f5f7fa;
    }
  }

  .action-col .cell {
    overflow: visible;
    white-space: nowrap;
    padding: 6px 8px;
  }

  .action-cell-nowrap {
    display: inline-flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    gap: 0;

    .el-button--text {
      padding: 0 6px;
      margin: 0;
      white-space: nowrap;
    }
  }

  .form-line {
    margin: 5px 0;
    .form-label {
      display: inline-block;
      width: 100px;
      text-align: right;
      margin-right: 10px;
    }

    .form-input {
      width: 220px;
    }
    .form-text {
      display: inline-block;
      line-height: 30px;
      height: 30px;
    }
  }

  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
    .greenText {
      color: red;
    }
    .greenYellowText {
      color: rgb(233, 104, 104);
    }
    .yellowText {
      color: rgb(112, 56, 56);
    }
  }

  .el-table tr:hover > td {
    background-color: #f5f9ff !important;
  }

  .el-table .current-row > td {
    background-color: #ecf5ff !important;
  }

  .upload-demo {
    text-align: right;
  }
}
</style>

<style lang="scss">
.pay-order-dialog {
  .el-dialog__body {
    padding-top: 10px;
  }
}
</style>
